import { CreateTemplateDto } from './create-template.dto';

export interface UpdateTemplateDto extends CreateTemplateDto {
  id: number;
}
